// utils/mapIcons.js
import L from 'leaflet';
import ReactDOMServer from 'react-dom/server';

import icon_line_ampang from '../assets/service_type_icon/icon_line_ampang.png'
import icon_line_sri_petaling from '../assets/service_type_icon/icon_line_sri-petaling.png'
import icon_line_kelana_jaya from '../assets/service_type_icon/icon_line_kelana-jaya.png'
import icon_line_kajang from '../assets/service_type_icon/icon_line_kajang-01.png'
import icon_line_putrajaya from '../assets/service_type_icon/icon_line_putrajaya.png'
import icon_kl_monorail from '../assets/service_type_icon/icon_line_kl-monorail.png'
import icon_klia_express from '../assets/service_type_icon/icon_line_klia-express.png'
import icon_brt from '../assets/service_type_icon/icon_brt.png'
import icon_bus from '../assets/service_type_icon/icon_bus.png'

const iconMap = {
    LRT: icon_line_ampang,
    KJ: icon_line_kelana_jaya,
    AG: icon_line_ampang,
    SP: icon_line_sri_petaling,

    MRT: icon_line_kajang,
    KG: icon_line_kajang,
    PYL: icon_line_putrajaya,

    Monorail: icon_kl_monorail,
    BRT: icon_brt,
    BUS: icon_bus,
    ERL: icon_klia_express,
};
export default iconMap;


export function createDivIcon(label) {
    return L.divIcon({
        html: `<div style="font-size: 18px; text-align: center;">${label}</div>`,
        className: 'custom-div-icon',
        iconSize: [30, 30],
        iconAnchor: [15, 30],
        popupAnchor: [0, -30],
    });
}

export function createLeafletIconFromJSX(iconJSX, bgColor = '#e60000') {
    const htmlString = ReactDOMServer.renderToString(
        <div
            style={{
                backgroundColor: bgColor,
                width: '20px',
                height: '20px',
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '10px',
                color: 'white',
            }}
        >
            {iconJSX}
        </div>
    );

    return L.divIcon({
        html: htmlString,
        className: '',
        iconSize: [20, 20],
        iconAnchor: [16, 32],
        popupAnchor: [0, -32],
    });
}

export function createLeafletIconFromImage(src, bgColor = '#e60000') {
    const htmlString = `
        <div style="
            width: 28px;
            height: 28px;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
        ">
            <img src="${src}" alt="" style="width: 20px; height: 20px;  border-radius: 50%;" />
        </div>
    `;

    return L.divIcon({
        html: htmlString,
        className: '',
        iconSize: [28, 28],
        iconAnchor: [14, 28],
        popupAnchor: [0, -28],
    });
}


